import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import ErrorDialog from './error-dialog'
const NoCreditDialog = ({ trigger, open }: { trigger: JSX.Element; open?: boolean }) => {
    const { t } = useTranslation('common')
    return (
        <ErrorDialog
            title={t('zeroCreditsTitle')}
            description={t('zeroCreditsMsg')}
            buttonText={t('zeroCreditsBtn')}
            open={open}
            trigger={trigger}
        />
    )
}

export default NoCreditDialog
